/* eslint-disable @typescript-eslint/dot-notation */
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { ContentService } from './../../services/content.service';
import { Content } from './../../model/content';
import { Component, OnInit } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.page.html',
  styleUrls: ['./pages.page.scss'],
})
export class PagesPage implements OnInit {
  pageArray = [];
  parents = [];
  inc = 0;
  order = {};
  newOrder = [{}];

  constructor(
    private contentService: ContentService,
    private fireStore: AngularFirestore,
    public authService: AuthenticationService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.authService.login();
    this.onListPages();
  }

  ionViewWillEnter() {
    if (this.authService.isLoggedIn === false) {
      this.router.navigateByUrl('/admin/login');
    }
  }

  onListPages() {
    const list = this.contentService.loadLiveList();
    list.valueChanges({ idField: 'id' }).subscribe((ss) => {
      this.pageArray = ss;
      // console.log(this.pageArray);
    });
    const parents = this.contentService.getAllParents();
    parents.valueChanges({ idField: 'id' }).subscribe((ss) => {
      this.parents = ss;
      // console.log(this.parents);
    });
  }

  onTogglePower(id: string, onOff: string) {
    this.contentService.togglePublished(id, onOff);
  }

  onDuplicate(id: string) {
    this.contentService.duplicatePage(id);
  }

  onDelete(id: string) {
    this.contentService.deletePage(id);
  }

  drop(event: CdkDragDrop<string[]>) {
    this.newOrder = [{}];
    moveItemInArray(this.pageArray, event.previousIndex, event.currentIndex);
    // console.log(this.pageArray);
    // this.pageArray.forEach(myFunction);
    // function myFunction(item,index,a) {
    //   a.order = item;
    // }
    this.inc = 1000;
    this.pageArray.forEach((val, index) => {
      // console.log(index);
      this.pageArray[index].order = this.inc;
      this.inc += 1000;
      // console.log(this.pageArray[index].id);
      const id = this.pageArray[index].id;
      this.order = {
        order: this.inc,
      };
      this.newOrder.push({
        id: this.pageArray[index].id,
        order: this.inc,
      });
      // console.log(this.newOrder);
      // const update = this.contentService.updatePage(id, this.order);
      // update.unsubscribe();
    });

    // console.log(this.pageArray);
    // console.log("previous: " + event.previousIndex + " current: " + event.currentIndex);
    this.newOrder.shift();
    console.log(this.newOrder);

    const batch = this.fireStore.firestore.batch();
    this.newOrder.forEach((val, index) => {
      const id = this.newOrder[index]['id'];
      const orderNum = this.newOrder[index]['order'];
      console.log (' id:' + id + ' order:' + orderNum);
      const pageRef = this.fireStore.doc(`content/${id}`).ref;
      batch.update(pageRef, {order:orderNum});
    });
    batch.commit();

    // for (let page of this.newOrder){
    //         const id = page.id;
    //         const orderNum = page.order;
    //         console.log ('id:' + id + ' order:' + orderNum);
    //         const pageRef = this.fireStore.doc('content/${id}').ref;
    //         batch.update(pageRef, {order:orderNum});
    //       }


    // const updateOrder = this.fireStore.collection('content')
    // .get()
    // .pipe(
    //   concatMap(results => {
    //     for (let page of this.newOrder){
    //       const id = page.id;
    //       const orderNum = page.order;
    //       console.log ('id:' + id + ' order:' + orderNum);
    //       const pageRef = this.fireStore.doc('content/${id}').ref;
    //       batch.update(pageRef, {order:orderNum});
    //     }
    //   })
    // );
  }
}
